<template>
  <div id="pageRoot">
    <p class="textBase appearAnimationB" id="text01" style="z-index: 6">
      Escribe el nombre de cada producto en el cuadro que corresponde.
    </p>

    <!-- TEXTS ----------------------------------------------------------------------------------------------------->
    <!-- TEXTS ----------------------------------------------------------------------------------------------------->

    <div
      class="basicItem01"
      id="tagPelota"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage75TagShorter.svg);
        background-size: cover;
      "
    >
      <p class="textBase tagText">pelota</p>
    </div>
    <div
      class="basicItem01"
      id="tagGalleta"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage75TagShorter.svg);
        background-size: cover;
      "
    >
      <p class="textBase tagText">galleta</p>
    </div>
    <div
      class="basicItem01"
      id="tagChorizo"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage71TagShort.svg);
        background-size: cover;
      "
    >
      <p class="textBase tagText">
        <span id="linethrough">chorizo</span>
      </p>
    </div>
    <div
      class="basicItem01"
      id="tagCuritas"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage75TagShorter.svg);
        background-size: cover;
      "
    >
      <p class="textBase tagText">curitas</p>
    </div>
    <div
      class="basicItem01"
      id="tagAsado"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage75TagShorter.svg);
        background-size: cover;
      "
    >
      <p class="textBase tagText">asado</p>
    </div>
    <div
      class="basicItem01"
      id="tagAlgodon"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage71TagShort.svg);
        background-size: cover;
      "
    >
      <p class="textBase tagText">algodón</p>
    </div>
    <div
      class="basicItem01"
      id="tagPan"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage75TagShorter.svg);
        background-size: cover;
      "
    >
      <p class="textBase tagText">pan</p>
    </div>
    <div
      class="basicItem01"
      id="tagRompecabezas"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage75TagMedium.svg);
        background-size: cover;
      "
    >
      <p class="textBase tagText">rompecabezas</p>
    </div>

    <div
      class="text-box-a pageElement hover-animation-a"
      id="textBox01"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage75TextBox01.svg);
        background-size: contain;
        background-repeat: no-repeat;
      "
    >
      <p class="textBase" id="textBox01Text">¡Me lastimé!</p>
    </div>
    <div
      class="text-box-a pageElement hover-animation-a"
      id="textBox02"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage75TextBox02.svg);
        background-size: contain;
        background-repeat: no-repeat;
      "
    >
      <p class="textBase" id="textBox02Text">¡Es mi cumpleaños!</p>
    </div>

    <p class="textBase" id="text02">FARMACIA</p>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
      style="z-index: 7"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
      class="pageElement"
      style="z-index: 7"
    />

    <p class="textBase" id="text03">JUGUETERÍA</p>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
      class="pageElement"
      style="z-index: 7"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="4"
      id="inputField04"
      class="pageElement"
      style="z-index: 7"
    />

    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
    <div class="pageSVG">
      <img
        src="/pages/img/sordo/svgPage76Background.svg"
        class="pageElement"
        style="width: 100%; height: auto"
      />
    </div>
    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
  </div>
</template>
<style scoped>
.tagText {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 5px;
  bottom: 0px;

  font-size: 36px;
  line-height: 49px;
  text-align: center;

  color: #fefafa;
}

#text02 {
  position: absolute;
  width: 216.98px;
  height: 63.56px;
  left: 193.27px;
  top: 459.92px;

  font-size: 33px;
  line-height: 45px;
  text-align: center;

  color: #fffcfc;

  transform: rotate(1.43deg);
}
#text03 {
  position: absolute;
  width: 216.98px;
  height: 63.56px;
  left: 592.74px;
  top: 460.83px;

  font-size: 33px;
  line-height: 45px;
  text-align: center;

  color: #fffcfc;

  transform: rotate(-1.88deg);
}
#inputField01 {
  position: absolute;
  width: 329px;
  left: 88px;
  top: 551px;
  height: 46px;

  font-size: 32px;
}
#inputField02 {
  position: absolute;
  width: 329px;
  left: 88px;
  top: 641px;
  height: 46px;

  font-size: 32px;
}
#inputField03 {
  position: absolute;
  width: 329px;
  height: 46px;
  left: 580px;
  top: 548px;

  font-size: 32px;
}
#inputField04 {
  position: absolute;
  width: 329px;
  height: 46px;
  left: 580px;
  top: 638px;
  font-size: 32px;
}
#text01 {
  position: absolute;
  width: 766px;
  height: 35px;
  left: 88px;
  top: 63px;

  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 25px;
}

#textBox01 {
  position: absolute;
  width: 301.53px;
  height: 123px;
  left: 62px;
  top: 316px;
}
#textBox01Text {
  position: absolute;
  width: 211px;
  height: 50px;
  left: 47.93px;
  top: 13px;

  font-size: 36px;
  line-height: 40px;
  /* or 111% */

  color: #fbf8f8;
}

#textBox02 {
  position: absolute;
  width: 372.83px;
  height: 132.51px;
  left: 506.59px;
  top: 303.11px;
}
#textBox02Text {
  position: absolute;
  left: 7.35%;
  right: 0.92%;
  top: 11%;
  bottom: 34.24%;

  font-size: 36px;
  line-height: 40px;
  /* or 111% */

  color: #fbf8f8;

  transform: rotate(0.92deg);
}

#tagAsado {
  position: absolute;
  width: 148px;
  height: 72.55px;
  left: 801px;
  top: 131px;
}
#tagPan {
  position: absolute;
  width: 117px;
  height: 70.55px;
  left: 417px;
  top: 225px;
}
#tagCuritas {
  position: absolute;
  width: 156px;
  height: 70.55px;
  left: 602px;
  top: 131px;
}
#tagPelota {
  position: absolute;
  width: 156px;
  height: 70.55px;
  left: 27px;
  top: 132px;
}
#tagAlgodon {
  position: absolute;
  width: 202px;
  height: 70.55px;
  left: 148px;
  top: 229px;
}
#tagRompecabezas {
  position: absolute;
  width: 305px;
  height: 70.55px;
  left: 639px;
  top: 223px;
}
#tagChorizo {
  position: absolute;
  width: 174px;
  height: 70.55px;
  left: 401px;
  top: 128px;
}
#tagGalleta {
  position: absolute;
  width: 156px;
  height: 70.55px;
  left: 209px;
  top: 136px;
}
#linethrough {
  text-decoration: line-through;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "p75-76/V58.mp4",
        "p75-76/V59.mp4",
        "p75-76/V60.mp4",
        "p75-76/V61.mp4",
        "p75-76/V62.mp4",
        "p75-76/V63.mp4",
        "p75-76/V64.mp4",
        "p75-76/V65.mp4",
        "p75-76/V66.mp4",
        "p76/V69.mp4",
        "p76/V70.mp4",
      ],
    };
  },
};
</script>